import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

let styles;

const Paragraph = props => (
  <div className={css(styles.container, props.styles)}>{props.children}</div>
);

export default Paragraph;

Paragraph.defaultProps = {
  styles: null,
};

Paragraph.propTypes = {
  styles: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ])),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.object,
    PropTypes.string,
  ]).isRequired,
};

styles = StyleSheet.create({
  container: {
    fontFamily: Theme.font_family_primary,
    fontSize: Theme.font_size_primary,
    fontWeight: Theme.font_weight_primary,
    lineHeight: 1.4,
    marginBottom: 10,
  },
});



// WEBPACK FOOTER //
// ./src/components/Paragraph/index.js